import React__default, { useCallback } from 'react';
import PT from 'prop-types';
import { S as SelectListContext } from './SelectListContext-b6ccf140.js';

const SelectList = ({
  onChange,
  selectedValue,
  noWrap,
  focusedValue,
  afterOnSelect,
  children
}) => {
  const handleClick = useCallback((value, event) => {
    onChange === null || onChange === void 0 || onChange(value, event);
  }, [onChange]);
  return children ? /*#__PURE__*/React__default.createElement(SelectListContext.Provider, {
    value: {
      focusedValue,
      noWrap,
      onClick: onChange ? handleClick : undefined,
      selectedValue,
      afterOnSelect
    }
  }, children) : null;
};
SelectList.propTypes = {
  onChange: PT.func,
  selectedValue: PT.any,
  children: PT.node,
  noWrap: PT.bool,
  focusedValue: PT.string,
  afterOnSelect: PT.func
};
SelectList.defaultProps = {
  onChange: undefined,
  selectedValue: undefined,
  children: undefined,
  noWrap: false,
  focusedValue: undefined,
  afterOnSelect: undefined
};
var SelectList$1 = SelectList;

export { SelectList$1 as S };
//# sourceMappingURL=SelectList-6e228538.js.map
